import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'logout-loader-modal',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './logout-loader-modal.component.html',
  styleUrl: './logout-loader-modal.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LogoutLoaderModalComponent implements OnInit {
  translation: any;

  constructor(
    private translationService: TranslationService
  ) {

  }

  ngOnInit(): void {
    this.translation = this.translationService.getTranslationForPage('home');
  }
}
